import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { brokerSuccessEmail, customerSuccessEmail } from '../store/emails/emailActions';
import Header from '../component/Header';
import Footer from '../component/Footer';
import './Thankyou.css';

function ThankYou() {
    const { id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const [emailSent, setEmailSent] = useState(false);

    // 1. Extract URL Parameters on mount
    useEffect(() => {
        const queryString = window.location.href.split("?")[1];
        if (queryString) {
            const params = new URLSearchParams(queryString);
            const data = Object.fromEntries(params.entries());
            setFormData(data);
        }
    }, []);

    // 2. Dispatch emails inside useEffect ONCE formData is populated
    useEffect(() => {
        // Ensure formData is ready, has a name, and emails haven't been sent yet
        if (!emailSent && id && formData.name) {

            // Helper to safely parse string "true"/"false" into actual C# booleans
            const parseBool = (val) => val === 'true' || val === true;

            const emailData = {
                toEmail: formData.clientEmail || '',
                fullName: formData.name || '',
                propertyAddress: [formData.address1, formData.address2, formData.address3]
                    .filter(Boolean)
                    .join(', '),
                coverDate: formData.coverDate || '',
                apmClientReference: formData.policyReference || '',
                postCode: formData.postcode || '',
                pReturn: formData.pReturn || '',
                pCode: formData.postcode || '',
                pRef: formData.policyReference || '',
                gadgetPurchased: parseBool(formData.gadgetPurchased),
                accountNumber: formData.accountNumber || '',
                sortCode: formData.sortCode || '',
                useraccountdetails: formData.accountHolderDetails || ''
            };

            const brokerEmailData = {
                toEmail: "sales@thamesbankinsurance.co.uk",
                sessionReference: formData.policyReference || '',
                clientReference: formData.policyReference || '',
                fullName: formData.name || '',
                postCode: formData.postcode || '',
                coverDate: formData.coverDate || '',
                premium: formData.payment || '0.00',
                insurerName: formData.insurer || '',
                schemeCode: formData.schemeCode || '',
                transactionAmount: formData.transactionamount || '0.00',
                adminCharge: formData.adminCharge || '0.00',
                pReturn: formData.pReturn || '',
                pCode: formData.postcode || '',
                pRef: formData.policyReference || '',
                legalPurchased: parseBool(formData.legalPurchased),
                emergencyPurchased: parseBool(formData.emergencyPurchased),
                keysPurchased: parseBool(formData.keysPurchased),
                gadgetPurchased: parseBool(formData.gadgetPurchased),
                accountNumber: formData.accountNumber || '',
                sortCode: formData.sortCode || '',
                useraccountdetails: formData.accountHolderDetails || '',
                clientEmail: formData.clientEmail || '',
                phone: formData.phone || ''
            };

            console.log('Sending Customer Email Payload:', emailData);
            console.log('Sending Broker Email Payload:', brokerEmailData);

            dispatch(customerSuccessEmail(emailData));
            dispatch(brokerSuccessEmail(brokerEmailData));
            setEmailSent(true);
        }
    }, [formData, id, emailSent, dispatch]);

    return (
        <>
            <Header />
            <div className='thankyou-page'>
                <div className='thankyou-main'>
                    <h1> Thank you for choosing Thamesbank <br />for your insurance. </h1>
                    <p>We are pleased to confirm receipt of your payment. </p>
                    <p>Your Insurance Policy has been successfully purchased. You can view your policy documents at any time, by logging in to your Portal.</p>
                    <p>You may have to register if you have not already done so.</p>
                    <a href='https://thamesbank.opencustomerportal.co.uk/view/account.jsp' className='btn btn-primary py-2'>Login Portal</a>

                    {formData.orderId && (
                        <div className="thank-you-container">
                            <div className="thank-you-card">
                                <div className="success-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <h2 className="thank-you-title">Payment Successful</h2>
                                <p className="thank-you-message">Thank you! Your transaction has been completed successfully.</p>

                                <div className="details-card">
                                    <div className="details-header">
                                        <h5 className="details-title">Transaction Receipt</h5>
                                        <span className="badge bg-success text-white" style={{ fontSize: '12px', padding: '8px 14px', borderRadius: '20px' }}>SUCCESS</span>
                                    </div>

                                    <div className="detail-row">
                                        <span className="detail-label">Email</span>
                                        <span className="detail-value">{formData.clientEmail}</span>
                                    </div>

                                    <div className="detail-row">
                                        <span className="detail-label">Address</span>
                                        <span className="detail-value">
                                            {[formData.address1, formData.address2, formData.address3].filter(Boolean).join(', ')}
                                        </span>
                                    </div>

                                    {formData.authCode && (
                                        <div className="detail-row">
                                            <span className="detail-label">Auth Code</span>
                                            <span className="detail-value">{formData.authCode}</span>
                                        </div>
                                    )}

                                    {formData.accountNumber && (
                                        <div className="detail-row">
                                            <span className="detail-label">Account Number</span>
                                            <span className="detail-value">****{formData.accountNumber.slice(-4)}</span>
                                        </div>
                                    )}
                                    {formData.sortCode && (
                                        <div className="detail-row">
                                            <span className="detail-label">Sort Code</span>
                                            <span className="detail-value">{formData.sortCode}</span>
                                        </div>
                                    )}
                                    {formData.pasRef && (
                                        <div className="detail-row">
                                            <span className="detail-label">Payment Ref</span>
                                            <span className="detail-value">{formData.pasRef}</span>
                                        </div>
                                    )}

                                    {formData.transactionamount && (
                                        <div className="total-row">
                                            <span className="total-label">Amount Paid</span>
                                            <span className="total-value">£{Number(formData.transactionamount).toFixed(2)}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default ThankYou;